import styled from '@emotion/styled';

const StyledTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
`;

export { StyledTitle };
